export function transformToReadable(text: string) {
  const words = text.split("_");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
  const transformedText = capitalizedWords.join(" ");
  return transformedText;
}

export function transformToCamelCase(text: string) {
  const words = text.split(" ");
  const camelCaseWords = words.map((word, index) =>
    index === 0
      ? word.toLowerCase()
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
  const transformedText = camelCaseWords.join("");
  return transformedText;
}

export function truncateMiddle(text = "", maxLength = 20) {
  if (text.length <= maxLength) return text;
  const start = text.slice(0, Math.floor(maxLength / 2));
  const end = text.slice(-Math.floor(maxLength / 2));
  return `${start}...${end}`;
}

export function formatSwiftCounterpartiesName(name: string, address: string) {
  const nameSplitted = name.split(" ");
  let nameFormatted: string = "";
  let keyReference: number = 0;

  for (const key in nameSplitted) {
    const newName = nameFormatted + nameSplitted[key] + " ";
    if (newName.length <= 35) {
      nameFormatted = newName;
    } else {
      keyReference = parseInt(key, 10);
      break;
    }
  }

  const remainingName = nameSplitted.slice(keyReference).join(" ");

  const addressFormatted = `${remainingName}/${address}`;

  return {
    name: nameFormatted.trim(),
    addressLine: addressFormatted.trim(),
  };
}
